import { useMediaQuery } from "@chakra-ui/react";
import { useEffect, useMemo, useState } from "react";

export const useMobile = (maxWidth = 768, delay = 200) => {
  const [initialized, setInitialized] = useState(false);
  const portraitMediaQuery = useMemo(
    () =>
      `only screen and (max-device-width: ${maxWidth}px) and (orientation: portrait)`,
    [maxWidth]
  );
  const landscapeMediaQuery = useMemo(
    () =>
      `only screen and (max-device-width: ${maxWidth}px) and (orientation: landscape)`,
    [maxWidth]
  );
  const [isPortrait, isLandscape] = useMediaQuery([
    portraitMediaQuery,
    landscapeMediaQuery,
  ]);

  const isMobile = useMemo(
    () => isPortrait || isLandscape,
    [isPortrait, isLandscape]
  );

  useEffect(() => {
    setTimeout(() => {
      setInitialized(true);
    }, delay);
  }, []);

  return { isMobile, isPortrait, isLandscape, initialized };
};
